import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Verificar se já está autenticado ao carregar
  useEffect(() => {
    const authStatus = localStorage.getItem('dashboardAuth');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const login = (username, password) => {
    const validUsername = process.env.REACT_APP_ADMIN_USERNAME || 'admin';
    const validPassword = process.env.REACT_APP_ADMIN_PASSWORD || 'Pwd@200101';

    if (username === validUsername && password === validPassword) {
      localStorage.setItem('dashboardAuth', 'true');
      localStorage.setItem('dashboardUser', username);
      setIsAuthenticated(true);
      return { success: true };
    }

    return { success: false, message: 'Credenciais inválidas' };
  };

  const logout = () => {
    localStorage.removeItem('dashboardAuth');
    localStorage.removeItem('dashboardUser');
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
